<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="serverError === null">

  <div class="row">

    <div class="col-md-6">
      <h2>
        Recently Active Customers
        <span *ngIf="loadingCustomers" class="text-secondary">- Loading...</span>
      </h2>
    </div>

    <div class="col-md-6 text-right">
      <select *ngIf="locations !== null"
              [(ngModel)]="locationId"
              (ngModelChange)="loadCustomers()"
              class="custom-select mr-2" style="width: auto;">
        <option [ngValue]="null">All Locations</option>
        <option *ngFor="let location of locations"
                [ngValue]="location.id">
          Location: {{ location.name }}
        </option>
      </select>
      <button class="btn btn-secondary"
              [class.disabled]="loadingCustomers"
              [disabled]="loadingCustomers"
              (click)="loadCustomers()">
        {{ loadingCustomers ? 'Loading...' : 'Refresh' }}
      </button>
    </div>

  </div>

  <div class="rounded-table-wrapper table-responsive-lg mt-3">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Activity</th>
        <th scope="col">Time</th>
        <th scope="col">Location</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="customers && (customers.length > 0)">
      <tr *ngFor="let customer of customers">
        <td>
          <ng-container *ngIf="customer.last_activity_type === CustomerActivityType.accountCreated">
            <a routerLink="/customers/{{ customer.id }}">
              <ng-container *ngIf="customer.preferred_name">{{ customer.preferred_name }}</ng-container>
              <ng-container *ngIf="!customer.preferred_name">{{ customer.first_name }}</ng-container>
              {{ customer.last_name }}'s
            </a>
            account was created
          </ng-container>
          <ng-container *ngIf="customer.last_activity_type === CustomerActivityType.profileEdited">
            <a routerLink="/customers/{{ customer.id }}">
              <ng-container *ngIf="customer.preferred_name">{{ customer.preferred_name }}</ng-container>
              <ng-container *ngIf="!customer.preferred_name">{{ customer.first_name }}</ng-container>
              {{ customer.last_name }}'s
            </a>
            profile was edited
          </ng-container>
          <ng-container *ngIf="![CustomerActivityType.accountCreated, CustomerActivityType.profileEdited].includes(customer.last_activity_type)">
            <a routerLink="/customers/{{ customer.id }}">
              <ng-container *ngIf="customer.preferred_name">{{ customer.preferred_name }}</ng-container>
              <ng-container *ngIf="!customer.preferred_name">{{ customer.first_name }}</ng-container>
              {{ customer.last_name }}
            </a>
            {{ uncapitalizeFirstLetter(getLastActivityText(customer, false)) }}
          </ng-container>
        </td>
        <td>
          <span [ngbTooltip]="timeStringFromISO8601(this.customer.last_activity_timestamp) + ' on ' + dateStringFromISO8601(this.customer.last_activity_timestamp)">
            {{ moment(customer.last_activity_timestamp).fromNow() }}
          </span>
        </td>
        <td>
          <span *ngIf="customer.last_activity_location_name">
            {{ customer.last_activity_location_name }}
          </span>
          <span *ngIf="!customer.last_activity_location_name" class="text-muted">
            N/A
          </span>
        </td>
        <td class="text-nowrap text-right" style="padding-top: 6px; padding-bottom: 0;">
          <a routerLink="/customers/{{ customer.id }}"
             class="btn btn-sm btn-outline-primary">
            Profile
          </a>
          <a [routerLink]="'/sale'"
             [queryParams]="{customerId: customer.id.toString()}"
             class="btn btn-sm btn-outline-primary ml-2">
            Sell Screen
          </a>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!customers || (customers.length === 0)">
      <tr>
        <td colspan="99">
          <span *ngIf="loadingCustomers">Loading...</span>
          <span *ngIf="!loadingCustomers">No customers active in last 24 hours</span>
        </td>
      </tr>
      </tbody>

    </table>
  </div>

</div>
